// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

const CONTAINS_NUMBER_REGEXP = /\d/;

export function validateCardHolderName(cardHolderName: string): ?UserInputValidationError {
  if(!cardHolderName || !cardHolderName.trim()) {
    return { id: 'empty' };
  }

  if(CONTAINS_NUMBER_REGEXP.test(cardHolderName)) {
    return { id: 'contains-number' };
  }

  if(cardHolderName.length > 50) {
    return { id: 'max-length' };
  }
}
